import { createRouter } from '@tanstack/react-router'

import { RouteErrorBoundary, RouteNotFound } from '@/components/layout/route-error'
import { queryClient } from '@/lib/query-client'
import { routeTree } from '@/routeTree.gen'

export const router = createRouter({
  routeTree,
  context: { queryClient },
  // hover / 触摸即预取,控制台切页几乎无等待
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: RouteErrorBoundary,
  defaultNotFoundComponent: RouteNotFound,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
